<template>
  <header>

    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 logo">
          <img src="/static/images/logo.svg" alt="">
        </div>
        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">


          <nav class="navbar d-none navbar-expand-lg ">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav mr-auto">
                <li class="nav-item active">
                  <router-link :to="{name:'Home'}" class="nav-link" >Home <span class="sr-only">(current)</span></router-link>
                </li>
                <li class="nav-item">
                  <router-link :to="{name:'Transactions'}" class="nav-link" >Transactions</router-link>
                </li>
                <li class="nav-item">
                  <router-link :to="{name:'Settlements'}" class="nav-link" >Settlements</router-link>
                </li>
                <li class="nav-item">
                  <router-link :to="{name:'Logs'}" class="nav-link" >Logs</router-link>
                </li>
              </ul>

            </div>
          </nav>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 text-right">

            <b-dropdown :right="true" variant="link" id="accountDropdown" size="sm"   >
              <template slot="button-content">
                <figure class="user-menu" >
                  <img src="/static/images/user-avatar.jpg" alt="User">
                </figure>
              </template>
              <!-- <b-dropdown-item><a href="javascript:void(0)">Profile</a></b-dropdown-item> -->
              <b-dropdown-item @click="logout">Logout</b-dropdown-item>
            </b-dropdown>



        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    name: 'PageHeader',
    props:[],
    data() {
      return {

      }
    },
    computed:{
      ...mapGetters([
        "sessionId"
      ])
    },
    methods:{
      logout() {
        this.$store.dispatch("logout", { sessionId:this.sessionId, }).then(()=>{
          location.reload()
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
@import '../assets/scss/custom.scss';
  /*----------------------------------*/
  /*---------- header style ----------*/
  header {
      background: $colorwhite;
      padding: rem(16px 0);
      .logo {
          img {
              height: rem(35px);
          }
      }
      .navbar-toggle {
          background: #ccc;
          .icon-bar {
              background: #333;
          }
      }
      .navbar {
          min-height: initial;
          margin: 0;
          border: none;
      }
      .navbar-nav {
          li {
              a {
                  padding: 0;
                  line-height: rem(35px);
                  font-size: rem(14px);
                  color: $basetextcolor;
                  text-transform: uppercase;
                  margin-right: rem(35px);
                  position: relative;
                  @include transition(all,0.1s,linear);
                  &:after {
                      content: '';
                      background: $secondaryColor;
                      position: absolute;
                      width: 0;
                      height: rem(3px);
                      left: 0;
                      bottom: rem(-22px);
                      @include transition(width,0.1s,linear);
                  }
                  &:hover {
                      background: transparent;
                      color: $darktextcolor;
                      &:after {
                          width: 100%;
                      }
                  }
                  &.active:after {
                      width: 100%;
                  }

                  &.router-link-exact-active:after{
                    width: 100%
                  }
              }
              &:last-child a {
                  margin-right: 0;
              }
          }
      }

      .user-menu {

        display: inline-block;
          margin-right: rem(15px);
          margin-bottom: 0;
          .dropdown-menu {
              right: 0;
              left: initial;
          }
          img {
              width: rem(40px);
              height: rem(40px);
              border-radius: 100%;
              margin-right: rem(5px);
          }
      }
  }
  .btn-link{
    background: #c00 !important;
  }
  .btn-link:hover{
    background: transparent !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/PageHeader.vue